import { IOBuffer } from 'iobuffer';
import { createStepArray } from 'ml-spectra-processing';

import * as aqModeDirect from '../constants/acquisitionModeDirect';

export async function setFIDSpectrumData(file, spectra) {
  let td = parseInt(spectra.meta.TD[0], 10);
  let ioBuffer = new IOBuffer(await file.arrayBuffer());

  if (td * spectra.meta.nbSubSpectra * 4 > ioBuffer.length) {
    throw new RangeError(
      `td: ${td} and nbSubSpectra: ${nbSubSpectra} exceed the buffer size`,
    );
  }

  const SW_H = parseFloat(spectra.meta.SW_h[0]);

  const SF = parseFloat(spectra.meta.SFO1[0]);
  const dtypa = parseInt(spectra.meta.DTYPA, 10);

  spectra.meta.DATATYPE = 'NMR FID';

  const DW = 1 / (2 * SW_H);
  const AQ = td * DW;
  let endian = parseInt(spectra.meta.BYTORDA, 10);
  endian = endian ? 0 : 1;

  if (endian) {
    ioBuffer.setLittleEndian();
  } else {
    ioBuffer.setBigEndian();
  }

  let nbSubSpectra = spectra.meta.nbSubSpectra
    ? spectra.meta.nbSubSpectra / 2
    : 1;

  spectra.spectra = new Array(nbSubSpectra);

  const aqMode = spectra.meta.AQ_mod;
  const deltaX = aqMode === aqModeDirect.QSEQ ? DW : 2 * DW;
  const nbPoints = aqMode === aqModeDirect.QSEQ ? td : (td / 2) >> 0;

  for (let j = 0; j < nbSubSpectra; j++) {
    let toSave = {
      dataType: 'NMR FID',
      dataTable: '(X++(R..R))',
      nbPoints,
      firstX: 0,
      lastX: AQ,
      nucleus: spectra.meta.NUC1,
      xUnit: 'Sec',
      yUnit: 'Arbitrary',
      data: {
        x: createStepArray({ length: nbPoints, step: deltaX }),
        re: new Float64Array(nbPoints),
        im: new Float64Array(nbPoints),
      },
      isXYdata: true,
      isFID: true,
      observeFrequency: SF,
      title: spectra.meta.TITLE,
      deltaX,
    };
    spectra.spectra[j] = toSave;

    const method = dtypa === 2 ? 'readFloat64' : 'readInt32';
    if (aqMode === aqModeDirect.QSEQ) {
      for (let i = 0; i < nbPoints; i++) {
        spectra.spectra[j].data.re[i] = ioBuffer[method]();
      }
    } else {
      for (let i = 0; i < nbPoints; i++) {
        spectra.spectra[j].data.re[i] = ioBuffer[method]();
        spectra.spectra[j].data.im[i] = ioBuffer[method]();
      }
    }
  }
}
